import { render, staticRenderFns } from "./the-header-account-action.vue?vue&type=template&id=5f7c99ca&"
import script from "./the-header-account-action.vue?vue&type=script&lang=js&"
export * from "./the-header-account-action.vue?vue&type=script&lang=js&"
import style0 from "./the-header-account-action.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports